const readableCampaignTypes = {
  DEFAULT: 'Standard',
  STATIC: 'Statisch',
  NEWSFLASH: 'Newsflash'
}

export default readableCampaignTypes
